<template>
    <div class="trial-card card">
        <div class="trial-card__column">
            <a :href="`/${data.url}`" class="trial-card__heading" @click="handleClick('title', $event)">{{ data.title }}</a>
            <span class="trial-card__status trial-status">Status:&#32;<span :class="data.status.toLowerCase()">{{ data.status }}</span></span>
            <div class="trial-card__body" v-html="data.excerpt" />
            <div class="trial-card__address">
                <a
                    :href="`/${data.url}`"
                    class="trial-card__location"
                    :aria-label="`View more information about ${data.location_title}`"
                    @click="handleClick('location_title', $event)"
                >
                    {{ data.location_title }}
                </a>
                <address class="address">
                    <a
                        :href="`//www.google.com/maps/search/?api=1&query=${data.lat },${ data.lng }`"
                        class="address__link"
                        :aria-label="`Click here for directions to ${ data.title }`"
                        @click="handleClick('location', $event)"
                    >
                        <span v-html="data.address"></span>
                    </a>
                </address>
            </div>
        </div>
        <div class="trial-card__column">
            <a
                :href="`/${data.url}`"
                class="button trial-card__button -outline"
                :aria-label="`Learn more about ${data.title}`"
                @click="handleClick('learn_more', $event)"
            >
                Learn More
            </a>
            <a
                :href="`tel:+1${data.phone_number}`"
                class="phone js-phone"
                v-if="data.phone_number"
                @click="handleClick('phone_number', $event)"
            >
                {{ data.phone_number }}
            </a>
        </div>
    </div>
</template>

<script>
import client from '../../../scripts/swiftypeClient';
import { swiftypeClickMixin } from '../../../scripts/mixins';

export default {
    name: 'clinicalTrial',
    props: ['data', 'requestId', 'query'],
    mixins: [swiftypeClickMixin],
};
</script>

